(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('valoracions', valoracions);

  function valoracions($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/valoracions/:idpartit/:idequip/:idperfil', {idpartit: '@_idpartit',idequip: '@_idequip',idperfil: '@_idperfil'}, {
      update: {
        method: 'PUT'
      }, insert: {
        method: 'POST'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


